import React, { useEffect, useState } from 'react';

import { WrappedControlProps } from 'app/components/Controls/WrappedControlProps';
import { validateZipCode } from 'app/validators';
import { useDidUpdateEffect } from 'app/shared/hooks/useDidUpdateEffect';
import { UtilService } from 'app/services/util.service';

export function useZipCodeControl({
  input,
  meta: { touched, valid },
  onClick,
  onValueChange,
  onControlBlur,
}: WrappedControlProps) {
  const [localValue, setLocalValue] = useState<string>(input.value || '');
  const [focused, setFocused] = useState(false);
  const onFocus = () => setFocused(true);
  const error = touched && !valid;
  const mask = '99-999';
  const maskChar = null;
  const isValueCheckVisible =
    valid && !focused && UtilService.hasValue(input.value);

  const onPropsValueChange = () => {
    if (input.value !== localValue) {
      setLocalValue(input.value);
    }
  };

  const onLocalValueChange = () => {
    if (localValue === '' || validateZipCode(localValue).valid) {
      notifyChange();
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setLocalValue(value);
  };

  const handleBlur = () => {
    input.onBlur(input.value);
    setFocused(false);

    if (!validateZipCode(localValue).valid) {
      setLocalValue('');
    }

    if (onControlBlur) {
      onControlBlur(false);
    }
  };

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  const notifyChange = () => {
    input.onChange(localValue);

    if (onValueChange) {
      onValueChange(localValue, true);
    }

    input.onBlur(localValue);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(onPropsValueChange, [input.value]);
  useDidUpdateEffect(onLocalValueChange, [localValue]);

  return {
    error,
    focused,
    handleBlur,
    handleChange,
    handleClick,
    isValueCheckVisible,
    localValue,
    mask,
    maskChar,
    onFocus,
  };
}
